import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import React from "react";

const DeleteUserModal = ({ user, handleDelete, isOpen, setIsOpen }) => {
  const toast = useToast({
    position: "right-bottom",
    duration: 3000,
    isClosable: true,
  });
  const { _id, name } = user;
  const cancelOperation = () => {
    toast({
      title: "Operation Cancelled",
      status: "info",
    });
    setIsOpen(false);
  };
  // modal to delete user based on the id
  // use tailwind and chakra-ui
  return (
    <Modal isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete User</ModalHeader>
        <ModalCloseButton onClick={cancelOperation} />
        <ModalBody>
          <p>Are you sure you want to delete {name}</p>
        </ModalBody>
        {/* <h1>Are you sure you want to delete {name}</h1> */}
        <ModalFooter gap="2">
          <Button colorScheme="green" onClick={() => handleDelete(_id)}>
            Yes
          </Button>
          <Button colorScheme="red" onClick={cancelOperation}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteUserModal;
